import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addSelectOptions, startAddSelectOptions } from '../../redux/actions/selects'
import { Select } from '../../@core/components/form/Select'
import ReactSelect from 'react-select'
import { selectThemeColors } from '../../utility/Utils'
import { editCollectionRegister } from '../../redux/actions/form'

const formatGroupLabel = (data) => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
)

export const ModelSelect = ({ containerClassname }) => {

    const { form, select } = useSelector(state => state)
    const dispatch = useDispatch()
    const { model } = select


    const handleChange = (target) => {
        const value = target ? target.value : null
        dispatch(editCollectionRegister(['vehicle'], { name: 'modelId', value }))
        dispatch(editCollectionRegister(['vehicle'], { name: 'modelStr', value: model.find(e => value === e.value)?.label || '' }))
    }

    useEffect(() => {
        if (!!form.vehicle?.brand && !!form.vehicle?.enrollmentDate && !!form.vehicle?.fuel && new Date(form.vehicle?.enrollmentDate)?.getFullYear() > 1980) {
            dispatch(startAddSelectOptions('model', 'model', ['model', 'cc'], { brandId: form.vehicle.brand, enrollmentDate: form.vehicle.enrollmentDate, fuel: form.vehicle.fuel }, true))
        } else {
            dispatch(editCollectionRegister(['vehicle'], { name: 'model', value: null }))
            dispatch(addSelectOptions('model', [].map(option => ({ label: option[labelName], value: option.id }))))
        }
    }, [form.vehicle?.brand, form.vehicle?.enrollmentDate, form.vehicle?.fuel])


    return (
        <div className={`col-6 mt-1 ${containerClassname}`}>
            <label className="control-label d-flex justify-content-between">Modelo</label>
            <ReactSelect
                key={`model_vehicle`}
                isClearable={true}
                name={'modelId'}
                isDisabled={(model?.length === 0 || !model)}
                classNamePrefix={'select'}
                theme={selectThemeColors}
                styles={{ menuPortal: base => ({ ...base, zIndex: 1051 }) }}
                options={model}
                formatGroupLabel={formatGroupLabel}
                menuPortalTarget={document.body}
                placeholder={'Modelo'}
                value={model?.find(o => o.value === form.vehicle?.modelId) || null}
                onChange={handleChange}
            />
        </div>
    )
}
